import { Typography, IconButton, Chip, Skeleton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { getUserDisplayName, getUserFirstName, useUser } from '$logic/users'
import ChipDeleteIcon from '$common/icons/chip-delete'
import { RemovePersonIcon } from '$common/icons/remove-person'
import { getUserImageUrl } from '$func/imageUrl'
import { AvatarBase } from '$common/avatar/avatar-base'
import { stringToColor } from '$func/string-to-color'
import { getAvatarText } from '$func/avatar-text'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledChip = styled(Chip)(({ theme }) => ({
  padding: 4,
  backgroundColor: theme.palette.neutral200,

  '.MuiChip-avatar': {
    margin: 0,
  },
  '.MuiChip-label': {
    margin: '0 5px',
    padding: 0,
  },
  '.MuiChip-deleteIcon': {
    margin: 0,
  },

  marginLeft: 6,
  marginRight: 0,

  '&:first-of-type': {
    marginRight: 15,
  },
  '&:last-child': {
    marginLeft: 15,
  },
}))

const StyledIconButton = styled(IconButton)`
  width: 20px;
  height: 20px;

  background-color: ${({ theme }) => theme.palette.neutral500};

  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral500};
  }
`

interface Props {
  id: string
  onDelete: (id: string) => void
}

export function UserChip({ id, onDelete }: Props) {
  const { user, err, loading } = useUser(id)

  const label = err ? 'error' : loading ? null : getUserDisplayName(user)
  const avatarSrc = getUserImageUrl(user)
  const backgroundColor = stringToColor(getUserFirstName(user), user?.id)
  return (
    <StyledChip
      avatar={
        <AvatarBase
          src={avatarSrc}
          backgroundColor={backgroundColor}
          size={AvatarSize._3XS}
          sx={{
            '&.MuiAvatar-root': {
              color: 'white',
              '& > svg': {
                fontSize: '18px',
              },
            },
          }}
        >
          {user?.deletedAt ? (
            <RemovePersonIcon />
          ) : (
            getAvatarText(getUserFirstName(user))
          )}
        </AvatarBase>
      }
      label={
        label ? (
          <Typography color="neutral900" variant="caption1">
            {label}
          </Typography>
        ) : (
          <Skeleton variant="text" />
        )
      }
      deleteIcon={
        <StyledIconButton>
          <ChipDeleteIcon sx={{ color: '#fff', fontSize: '8px' }} />
        </StyledIconButton>
      }
      onDelete={onDelete}
    />
  )
}
